module.exports = __webpack_public_path__ + "img/teeth-15.47a67fc0.png";